(function () {
  function setQueryParam(name, value) {
    var url = new URL(window.location.href);
    if (value === null || value === '') url.searchParams.delete(name);
    else url.searchParams.set(name, value);
    url.searchParams.delete('page');
    window.location.assign(url.toString());
  }

  /*
    Shelf order is Atlas's (Merch Guard R9: DTC revenue × availability weight,
    written daily as the collection's manual order). Since 2026-09-03 the grid
    no longer re-partitions "last sizes" cards to the page bottom — that fought
    the ranking on the same page. Band 2 (sold out) is a no-op safety net: the
    snippet already hides those server-side.
  */
  function demoteSoldOut(root) {
    var grid = root.querySelector('[data-r1-product-grid]');
    if (!grid) return;

    Array.prototype.slice.call(grid.querySelectorAll('[data-r1-product-card][data-r1-band="2"]'))
      .forEach(function (card) { grid.appendChild(card); });

    var editorial = grid.querySelector('[data-r1-editorial]');
    if (editorial) {
      var position = Math.max(1, parseInt(editorial.dataset.r1Position || '8', 10));
      var cards = grid.querySelectorAll('[data-r1-product-card]');
      var anchor = cards[Math.min(position, cards.length) - 1];
      if (anchor) anchor.insertAdjacentElement('afterend', editorial);
    }
  }

  /*
    Per-market order. Shopify holds one order per collection (Atlas writes the
    blended one); each card also carries Atlas's two market scores
    (atlas.shelf_scores = {eu, us}) and the root says which warehouse ships
    this visitor (Shopify localization: US → Anchor, everyone else → 360).
    Stable sort by that score; cards without a score keep their order behind
    the scored ones. Skipped on user-chosen sorts and when scores are sparse.
  */
  function sortByMarketScore(root) {
    var grid = root.querySelector('[data-r1-product-grid]');
    if (!grid) return;
    var params = new URL(window.location.href).searchParams;
    var sortBy = params.get('sort_by');
    if (sortBy && sortBy !== 'manual') return;
    var warehouse = root.getAttribute('data-r1-warehouse') === 'us' ? 'us' : 'eu';
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-r1-product-card]'));
    if (cards.length < 2) return;
    var scored = 0;
    var entries = cards.map(function (card, index) {
      var score = null;
      try {
        var raw = card.getAttribute('data-r1-scores');
        var parsed = raw ? JSON.parse(raw) : null;
        if (parsed && typeof parsed[warehouse] === 'number') { score = parsed[warehouse]; scored++; }
      } catch (e) { score = null; }
      return { card: card, index: index, score: score };
    });
    if (scored * 2 < cards.length) return;
    entries.sort(function (a, b) {
      if (a.score === null && b.score === null) return a.index - b.index;
      if (a.score === null) return 1;
      if (b.score === null) return -1;
      return (b.score - a.score) || (a.index - b.index);
    });
    entries.forEach(function (entry) { grid.appendChild(entry.card); });
  }

  /* Count sellable products, not colour cards (a product listed in three colours is one product). */
  function updateCount(root) {
    var count = root.querySelector('[data-r1-visible-count]');
    if (!count) return;
    var ids = {};
    var n = 0;
    root.querySelectorAll('[data-r1-product-card]').forEach(function (card) {
      var id = card.getAttribute('data-product-id') || '';
      if (card.getAttribute('data-r1-band') === '2') return;
      if (!ids[id]) { ids[id] = true; n++; }
    });
    count.textContent = n;
  }

  /*
    A size or colour filter means "in that size/colour, in stock". Shopify's
    option facet matches variant existence, so without the availability facet
    a "M" filter lists products whose M is sold out (4 of 21 on Mens, QA
    2026-09-03). Two hooks: the facet form (AJAX path) and the URL (deep links).
  */
  function hasOptionFilter(params) {
    var found = false;
    params.forEach(function (value, key) {
      if (key.indexOf('filter.v.option.') === 0 && value !== '') found = true;
    });
    return found;
  }

  function ensureAvailabilityOnUrl() {
    var url = new URL(window.location.href);
    if (hasOptionFilter(url.searchParams) && url.searchParams.get('filter.v.availability') !== '1') {
      url.searchParams.set('filter.v.availability', '1');
      window.location.replace(url.toString());
      return true;
    }
    return false;
  }

  function bindFacetForms() {
    document.querySelectorAll('form[is="facet-form"]').forEach(function (form) {
      if (form.dataset.r1Availability === 'true') return;
      form.dataset.r1Availability = 'true';
      form.addEventListener('change', function (event) {
        var target = event.target;
        if (!target || !target.name || target.name.indexOf('filter.v.option.') !== 0 || !target.checked) return;
        var availability = form.querySelector('input[name="filter.v.availability"]');
        if (availability && !availability.checked) availability.checked = true;
      }, true);
    });
  }

  /*
    The toolbar survives the theme's facet AJAX render (only #ProductGridContainer,
    #ProductCount and the facet drawer are replaced), and collection:reloaded
    re-runs initCollection on the same root. Bind each control once and read
    the filter state from the URL at click time, otherwise every reload stacked
    another listener with a stale "active" flag.
  */
  function syncInStock(root) {
    var inStock = root.querySelector('[data-r1-in-stock]');
    if (!inStock) return;
    var params = new URL(window.location.href).searchParams;
    inStock.setAttribute('aria-pressed', String(params.get('filter.v.availability') === '1'));
    if (inStock.dataset.r1Bound === 'true') return;
    inStock.dataset.r1Bound = 'true';
    inStock.addEventListener('click', function () {
      var active = new URL(window.location.href).searchParams.get('filter.v.availability') === '1';
      setQueryParam('filter.v.availability', active ? null : '1');
    });
  }

  function bindSort(root) {
    var sort = root.querySelector('[data-r1-sort]');
    if (!sort || sort.dataset.r1Bound === 'true') return;
    sort.dataset.r1Bound = 'true';
    sort.addEventListener('change', function () {
      setQueryParam('sort_by', sort.value);
    });
  }

  function initCollection(root) {
    if (!root || root.dataset.r1Ready === 'true') return;
    root.dataset.r1Ready = 'true';

    syncInStock(root);
    bindSort(root);
    sortByMarketScore(root);
    demoteSoldOut(root);
    updateCount(root);
  }

  function initAll() {
    if (ensureAvailabilityOnUrl()) return;
    bindFacetForms();
    document.querySelectorAll('[data-r1-collection]').forEach(initCollection);
  }

  function refreshAll() {
    bindFacetForms();
    document.querySelectorAll('[data-r1-collection]').forEach(function (root) {
      root.dataset.r1Ready = '';
      initCollection(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('collection:reloaded', refreshAll);
})();
